// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKSocialButton from "components/MKSocialButton";

// Material Kit 2 React examples
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import DefaultFooter from "examples/Footers/CustomFooter";
//import FilledInfoCard from "examples/Cards/InfoCards/FilledInfoCard";

// Presentation page sections
import Counters from "pages/Presentation/sections/Counters";
//import WreckReef from "pages/Presentation/sections/WreckReef";
import Information from "pages/Presentation/sections/Information";
import DesignBlocks from "pages/Presentation/sections/DesignBlocks";
import GoogleReviews from "pages/Presentation/sections/Greview";
//import Testimonials from "pages/Presentation/sections/Testimonials";
//import Download from "pages/Presentation/sections/Download";

// Presentation page components
import BuiltByDevelopers from "pages/Presentation/components/BuiltByDevelopers";

// Routes
import routes from "routes";
//import footerRoutes from "footer.routes";

// Images
import bgImage from "assets/images/Activities.JPG";
import footbgImage from "assets/images/footerBeach.jpg";

function Presentation() {
  //const description = (
  //  <>
  //    Duration: 2–3 hours <br />
  //    Includes: Briefing, shallow water training + 1 dive <br />
  //    Perfect for: Beginners <br />
  //    Price: LKR 12,000 / USD 35
  //  </>
  //);
  // const description2 = (
  //  <>
  //   Duration: Approx. 45 mins dive <br />
  //   Includes: Equipment, boat ride, guide <br />
  //   Requirements: Open Water certification <br />
  //   Locations: Trincomalee, Mirissa (based on season) <br />
  //   Price: LKR 8,500 / USD 25
  // </>
  // );
  //const description3 = (
  // <>
  //   Includes: 2 guided dives, full gear, surface interval refreshments <br />
  //   Locations: Hikkaduwa, Trincomalee, Mirissa (based on season) <br />
  //   Price: LKR 16,000 / USD 45
  // </>
  //);
  return (
    <>
      <DefaultNavbar routes={routes} sticky />
      <MKBox
        minHeight="75vh"
        width="100%"
        sx={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.38)),url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "top",
          display: "grid",
          placeItems: "center",
        }}
      >
        <Container>
          <Grid container item xs={12} lg={7} justifyContent="center" mx="auto">
            <MKTypography
              variant="h1"
              color="white"
              mt={-6}
              mb={1}
              sx={({ breakpoints, typography: { size } }) => ({
                [breakpoints.down("md")]: {
                  fontSize: size["3xl"],
                },
              })}
            >
              Scuba Addicts{" "}
            </MKTypography>
            <MKTypography
              variant="body1"
              color="white"
              textAlign="center"
              px={{ xs: 6, lg: 12 }}
              mt={1}
            >
              Warmly welcome you to plunge into your underwater addiction to the next level..
            </MKTypography>
          </Grid>
        </Container>
      </MKBox>
      <Card
        sx={{
          p: 2,
          mx: { xs: 2, lg: 3 },
          mt: -8,
          mb: 4,
          backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
          backdropFilter: "saturate(200%) blur(30px)",
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        <Counters />
        <Information />
        <GoogleReviews />
        <Container sx={{ mt: 6 }}>
          <BuiltByDevelopers />
        </Container>
        <DesignBlocks />
        <MKBox
          pt={18}
          pb={6}
          sx={{
            backgroundImage: `url(${footbgImage})`,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "bottom center",
            backgroundSize: "cover",
          }}
        >
          <Container>
            <Grid container spacing={3}>
              <Grid item xs={12} lg={5} ml="auto" sx={{ textAlign: { xs: "center", lg: "left" } }}>
                <MKTypography variant="h4" fontWeight="bold" mb={0.5}>
                  Thank you for your support!
                </MKTypography>
                <MKTypography variant="body1" color="text">
                  We deliver the best dive service
                </MKTypography>
              </Grid>
              <Grid
                item
                xs={12}
                lg={5}
                my={{ xs: 5, lg: "auto" }}
                mr={{ xs: 0, lg: "auto" }}
                sx={{ textAlign: { xs: "center", lg: "right" } }}
              >
                <MKSocialButton
                  component="a"
                  href="https://www.tripadvisor.com/Attraction_Review-g2193270-d17513270-Reviews-Scuba_Addicts_Dive_Center_Passikuda-Kalkudah_Eastern_Province.html"
                  target="_blank"
                  color="#38cb82"
                  sx={{ backgroundColor: "#38cb82", mr: 1 }}
                >
                  <i className="fab fa-tripadvisor" />
                  &nbsp;Tripadviser
                </MKSocialButton>
                <MKSocialButton
                  component="a"
                  href="https://www.facebook.com/scubaaddictssrilanka"
                  target="_blank"
                  color="facebook"
                  sx={{ mr: 1 }}
                >
                  <i className="fab fa-facebook" />
                  &nbsp;Share
                </MKSocialButton>
                <MKSocialButton
                  component="a"
                  href="https://www.instagram.com/scubaaddicts.sl/?igsh=NnZjNjgyN3I0d2ls#"
                  target="_blank"
                  color="instagram"
                >
                  <i className="fab fa-instagram" />
                  &nbsp;Instagram
                </MKSocialButton>
              </Grid>
            </Grid>
          </Container>
        </MKBox>
      </Card>
      <MKBox pt={6} px={1} mt={6}>
        <DefaultFooter />
      </MKBox>
    </>
  );
}

export default Presentation;
